import { Flex } from '@pancakeswap/uikit'
import TokenLogo from '@pancakeswap/uikit/components/Svg/Icons/TokenLogo'
import styled from 'styled-components'
import ResultTypeGroup from './ResultTypeGroup'

const Wrapper = styled(Flex)`
  display: flex;
  padding: 20px 0px 20px 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
  overflow-y: auto;
`
const resultTypeConfig = Array(10)
  .fill(null)
  .flatMap((_, i) => [
    {
      id: `tokens-${i}`, // add this
      title: 'TOKENS',
      items: [
        {
          icon: TokenLogo,
          text: 'BOMB',
          description: 'BOMB Memes - 0x1234...123456',
        },
        {
          icon: TokenLogo,
          text: 'BOR',
          description: 'Boromir Finance - 0x1234...123456',
        },
      ],
    },
  ])

const Results = () => {
  return (
    <Wrapper>
      {resultTypeConfig.map((result) => {
        return <ResultTypeGroup key={result.id} title="Tokens" items={result.items} />
      })}
    </Wrapper>
  )
}

export default Results
